// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import Datacenter from '../../img/pro/product_datacenter_48.svg';
import Isp from '../../img/pro/product_isp_48.svg';
import Shared from '../../img/pro/product_shared_48.svg';
import {hola_pro_products} from 'hola_opt';
import experiment_init from '../../experiment_init';

type title_fn = (q:number)=>string;
const get_price = (id:string, quantity:number, title: title_fn)=>{
    if (!hola_pro_products || !hola_pro_products[id])
    {
        return {
            value: `${quantity}`,
            title: `${quantity}`,
            price_by_one: `$0`,
            price: 0,
            unit: '',
            total_price: `$0.00`
        };
    }
    const prod = hola_pro_products[id];
    let unit_price = prod.price;
    let unit_decimal = 2;
    let total_decimal = 2;
    if (experiment_init.ui_test.test_discount_prices)
    {
        if (prod.discount_rules)
        {
            for (let rule of prod.discount_rules)
            {
                if (quantity <= rule.max_quantity)
                {
                    unit_price = rule.price;
                    unit_decimal = rule.unit_decimal;
                    total_decimal = rule.total_decimal;
                    break;
                }
            }
        }
    }
    const rounded_unit_price = Number(unit_price.toFixed(unit_decimal));
    const total_price_value = unit_price * quantity;
    const rounded_total_price = total_decimal==0
        ? Math.round(total_price_value * 2) / 2
        : Number(total_price_value.toFixed(total_decimal));
    return {
        value: `${quantity}`,
        title: title(quantity),
        price_by_one: `$${rounded_unit_price.toFixed(unit_decimal)}/${
            (prod.unit || '').toUpperCase()}`,
        price: rounded_unit_price,
        unit: prod.unit,
        type: prod.bd_type,
        total_price: `$${rounded_total_price.toFixed(2)}`
    };
};

type product_type = 'toolip'|'pro'|'oculus'

export const get_list_of_products = (type?: product_type)=>{
    const payment_methods = [{
        id: 'cc',
        title: 'Credit Card',
    }, {
        id: 'paypal',
        title: 'PayPal',
        disabled: true,
    }, {
        id: 'google',
        title: 'Google Pay',
        disabled: true,
    }, {
        id: 'other',
        title: 'Other',
        disabled: true,
    }];
    const shared_dc_q = type=='toolip' ? [50, 100, 150, 200, 250, 300]
        : [5, 10, 20, 50, 100, 200];
    return [{
        value: 'dedicated_dc', // XXX dmitriiz: replace with plan id
        url_id: 'dedicated-datacenter',
        title: 'Dedicated Datacenter Proxies',
        icon: <Datacenter />,
        five_pluses: ['SOCKS5 Support', '99.99% uptime', '20GB limit per IP',
            'Exclusively yours', 'Flat fees, no hidden costs'],
        buy_label: 'Quantity per month',
        buy_label_short: 'IP Qty',
        additional: '100GB per IP included',
        prices: [25, 50, 100, 200].map(c=>get_price('dedicated_dc', c,
          a=>`${a}`)),
        payment_methods,
    }, {
        value: 'shared_dc', // XXX dmitriiz: replace with plan id
        url_id: 'shared-datacenter',
        title: 'Shared Datacenter Proxies',
        icon: <Shared />,
        five_pluses: ['SOCKS5 Support', '99.99% Uptime',
            '20GB limit per IP', 'Huge pool of IPs',
            'Flat fees, no hidden costs'],
        buy_label: 'Bandwidth',
        buy_label_short: 'Bandwidth',
        additional: 'Package valid for 3 months',
        prices: shared_dc_q.map(c=>get_price('shared_dc', c,
            a=>`${a} GB`)),
        payment_methods,
    }, ...type == 'oculus' ? [{
        value: 'shared_isp', // XXX dmitriiz: replace with plan id
        url_id: 'shared_isp',
        title: 'ISP Proxies',
        icon: <Isp />,
        five_pluses: ['SOCKS5 Support', '99.99% uptime', 'Unlimited bandwidth',
            'Real Static Residential IPs ', 'Flat fees, no hidden costs'],
        buy_label: 'Bandwidth',
        buy_label_short: 'Bandwidth',
        additional: 'Package valid for 3 months',
        prices: [5, 10, 20, 50, 100, 200].map(c=>get_price('shared_isp', c,
            a=>`${a} GB`)),
        payment_methods,
    },
    {
        value: 'events_isp',
        url_id: 'events_isp',
        title: 'Events & E-commerce ISP',
        icon: <Isp />,
        five_pluses: ['SOCKS5 Support', '99.99% uptime', 'Unlimited bandwidth',
            'Real Static Residential IPs ', 'Flat fees, no hidden costs'],
        buy_label_short: 'IP Qty',
        additional: 'Package valid for 1 months',
        prices: [1, 30, 50, 200].map(c=>get_price('events_isp', c,
            a=>`${a} GB`)),
        payment_methods,
    }] : [{
        value: 'isp', // XXX dmitriiz: replace with plan id
        url_id: 'isp-proxy',
        title: 'Global ISP Proxies',
        icon: <Isp />,
        five_pluses: ['SOCKS5 Support', '99.99% uptime', 'Unlimited bandwidth',
            'Real Static Residential IPs ', 'Flat fees, no hidden costs'],
        buy_label: 'Bandwidth',
        buy_label_short: 'Bandwidth',
        additional: 'Package valid for 3 months',
        prices: [5, 10, 20, 50, 100, 200].map(c=>get_price('isp', c,
            a=>`${a} GB`)),
        payment_methods,
    }]].concat(type=='toolip' || type=='oculus' ? [{
        value: 'smart_resi',
        url_id: 'residential-proxy',
        title: 'Rotating Residential Proxies',
        icon: <Isp />,
        five_pluses: ['SOCKS5 support', '99.99% uptime', 'High anonymity',
            'Real Residential IPs', 'Flat fees, no hidden costs'],
        buy_label: 'Bandwidth',
        buy_label_short: 'Bandwidth',
        additional: 'Package valid for 3 months',
        prices: [5, 10, 20, 50, 100, 200].map(c=>get_price('smart_resi', c,
            a=>`${a} GB`)),
        payment_methods,
    },
    {
        value: 'events_resi_tickets',
        url_id: 'events_resi_tickets',
        title: 'Events Tickets Residential Proxies',
        icon: <Isp />,
        five_pluses: ['SOCKS5 support', '99.99% uptime', 'High anonymity',
            'Real Residential IPs', 'Flat fees, no hidden costs'],
        buy_label: 'Bandwidth',
        buy_label_short: 'Bandwidth',
        additional: 'Package valid for 3 months',
        prices: [5, 10, 20, 50, 100, 200].map(c=>get_price('smart_resi', c,
            a=>`${a} GB`)),
        payment_methods,
    },
    {
        value: 'resi_sneakers',
        url_id: 'resi_sneakers',
        title: 'Sneakers Residential Proxies',
        icon: <Isp />,
        five_pluses: ['SOCKS5 support', '99.99% uptime', 'High anonymity',
            'Real Residential IPs', 'Flat fees, no hidden costs'],
        buy_label: 'Bandwidth',
        buy_label_short: 'Bandwidth',
        additional: 'Package valid for 3 months',
        prices: [5, 10, 20, 50, 100, 200].map(c=>get_price('resi_sneakers', c,
            a=>`${a} GB`)),
        payment_methods,
    },
    {
        value: 'isp_plus',
        url_id: 'isp-proxy/pro',
        title: 'Search Engine ISP Proxies',
        icon: <Isp />,
        five_pluses: ['SOCKS5 Support', '99.99% uptime', 'Unlimited bandwidth',
            'Real Static Residential IPs ', 'Flat fees, no hidden costs'],
        buy_label: 'Quantity per month',
        buy_label_short: 'IP Qty',
        additional: 'Package valid for 1 months',
        prices: [1, 30, 50, 200].map(c=>get_price('isp_plus', c,
            a=>`${a} IP`)),
        payment_methods,
    },
    {
        value: 'events_resi_group',
        url_id: 'events_resi_group',
        title: 'Static Residential Proxies',
        icon: <Isp />,
        five_pluses: ['SOCKS5 Support', '99.99% uptime', 'Unlimited bandwidth',
            'Real Static Residential IPs ', 'Flat fees, no hidden costs'],
        buy_label: 'Quantity per month',
        buy_label_short: 'IP Qty',
        additional: 'Package valid for 1 months',
        prices: [1, 30, 50, 200].map(c=>get_price('isp_plus', c,
            a=>`${a} IP`)),
        payment_methods,
    },
    {
        value: 'unknown',
        url_id: 'shared-datacenter',
        title: 'Proxies',
        icon: <Datacenter />,
        five_pluses: ['SOCKS5 Support', '99.99% uptime', 'Unlimited bandwidth',
            'Real Static Residential IPs ', 'Flat fees, no hidden costs'],
        buy_label: 'Quantity per month',
        buy_label_short: 'IP Qty',
        additional: 'Package valid for 1 months',
        prices: [1, 30, 50, 200].map(c=>get_price('isp_plus', c,
            a=>`${a} IP`)),
        payment_methods,
    }] : null).filter(Boolean);
};
